import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './ProductDetail.css';

function ProductDetail({ product, onClose, onAddToCart }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Get all product images (main + additional)
  const images = [
    product.imageUrl,
    ...(product.additionalImages || [])
  ].filter(Boolean);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
    if (isRightSwipe && currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const nextImage = () => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const prevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleAddToCart = () => {
    onAddToCart({ ...product, quantity });
    onClose();
  };

  return (
    <div className="product-detail-overlay" onClick={onClose}>
      <div className="product-detail-panel" onClick={(e) => e.stopPropagation()}>
        <button className="detail-close-btn" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="product-detail-content">
          {/* Image Gallery */}
          <div className="product-detail-gallery">
            <div 
              className="gallery-main"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <img 
                src={images[currentImageIndex]} 
                alt={product.name}
                className="gallery-main-image"
              />
              
              {images.length > 1 && (
                <>
                  {currentImageIndex > 0 && (
                    <button className="gallery-nav-btn prev" onClick={prevImage}>
                      <ChevronLeft size={24} />
                    </button>
                  )}
                  {currentImageIndex < images.length - 1 && (
                    <button className="gallery-nav-btn next" onClick={nextImage}>
                      <ChevronRight size={24} />
                    </button>
                  )}
                </>
              )}

              {/* Image Indicators */}
              {images.length > 1 && (
                <div className="gallery-indicators">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => setCurrentImageIndex(index)}
                    />
                  ))}
                </div>
              )}
            </div>

            {/* Thumbnail Strip */}
            {images.length > 1 && (
              <div className="gallery-thumbnails">
                {images.map((image, index) => (
                  <button
                    key={index}
                    className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  >
                    <img src={image} alt={`${product.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Product Info */}
          <div className="product-detail-info">
            <div className="detail-category-badge" style={{ backgroundColor: '#10b981' }}>
              {product.category}
            </div>
            
            <h2 className="detail-product-name">{product.name}</h2>
            
            <div className="detail-product-price">${product.price.toFixed(2)}</div>
            
            <p className="detail-product-description">{product.description}</p>

            {/* Quantity Selector */}
            <div className="detail-quantity-section">
              <label>Quantity:</label>
              <div className="quantity-controls">
                <button 
                  className="qty-btn"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                >
                  -
                </button>
                <span className="qty-display">{quantity}</span>
                <button 
                  className="qty-btn"
                  onClick={() => setQuantity(quantity + 1)}
                >
                  +
                </button>
              </div>
            </div>

            {/* Add to Cart Button */}
            <button className="detail-add-to-cart-btn" onClick={handleAddToCart}>
              Add to Cart - ${(product.price * quantity).toFixed(2)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
